import { agPriceCol, exchangeRateCol } from '@/ag-grid/ag-columns'
import { notAnyPriceCheck } from '@/ag-grid/utils/notAnyValue'
import { cloneDeep } from 'lodash'
import { priceRenderer } from '@lib/generic.utils'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Description',
            field: 'description',
            editable: params => !params.data.is_static,
            cellEditorFramework: 'TextEditor',
            cellClassRules: {
              'editable-cell': params => !params.data.is_static
            },
            cellRenderer: params => {
              if (params.data.is_original && !params.value) return this.defaultDescription
              return params.value ?? 'N/A'
            }
          },

          agPriceCol('Final Price', 'price', {
            editable: params => params.data.id !== 'current_total',
            cellClassRules: {
              'editable-cell': params => params.data.id !== 'current_total',
              'ag-right-aligned-cell': params => true
            },
            cellRenderer: params => notAnyPriceCheck(params, 'subscription_period.currency')
          }),

          exchangeRateCol({
            cellRenderer: params => {
              if (params.data.id === 'current_total') return null
              return priceRenderer(params.data.exchange_rate, 4) || 'N/A'
            },
            editable: params => params.data.id !== 'current_total',
            cellClassRules: {
              'editable-cell': params => params.data.id !== 'current_total',
              'ag-right-aligned-cell': params => true
            }
          }),

          agPriceCol('Price in Local Currency', 'normalized_price', {
            headerClass: ['text-right', 'multiple-lines'],
            cellRenderer: params => notAnyPriceCheck(params, 'subscription_period.normalized_currency'),
            editable: params => params.data.id !== 'current_total',
            cellClassRules: {
              'editable-cell': params => params.data.id !== 'current_total',
              'ag-right-aligned-cell': params => true
            }
          }),

          {
            headerName: 'Actions',
            cellRendererFramework: 'ActionsCol',
            sortable: false,
            lockVisible: true,
            maxWidth: 100,
            type: 'centerAligned',
            cellRendererParams: params => {
              return {
                hide: params.data.id === 'current_total',
                popupActions: [
                  {
                    name: 'delete',
                    label: 'Delete',
                    textColorClass: 'text-danger-1',
                    disable: params.data.is_original === true || params.data.is_static === true
                  }
                ],

                onPopupAction: event => {
                  if (event === 'delete') this.deleteItem(params.data.id)
                }
              }
            }
          }
        ],

        domLayout: 'autoHeight'
      }
    }
  },

  methods: {
    getPinnedBottomRowData() {
      return {
        is_static: true,
        id: 'current_total',
        description: 'Current Total',
        price: 0,
        exchange_rate: null,
        normalized_price: 0,
        subscription_period: cloneDeep(this.period)
      }
    },

    generatePinnedBottomRow() {
      const pinnedBottomRowData = this.getPinnedBottomRowData()

      this.agGrid.api.forEachNodeAfterFilter(rowNode => {
        const rowData = rowNode.data
        pinnedBottomRowData.price += +rowData.price
        pinnedBottomRowData.normalized_price += +rowData.normalized_price
      })

      return pinnedBottomRowData
    }
  }
}
